import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../_service/authentication.service';
import { PasswordValidator } from '../_validator/password-validator';

@Component({
    templateUrl: 'reset.component.html',
    styleUrls: ['reset.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ResetComponent implements OnInit {
    resetForm: UntypedFormGroup;
    loading = false;
    error = '';
    sent = false;
    token = '';
    submitted = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();
        this.token = this.route.snapshot.queryParams['token'];

        this.resetForm = this.formBuilder.group({
            password: ['', [Validators.required, PasswordValidator.strongPassword()]],
            confirmPassword: ['', Validators.required]
        }, {
            validator: this.passwordMatchValidator
        });
    }

    // Convenience getter for easy access to form fields
    get f() { return this.resetForm.controls; }

    // Custom validator to check that passwords match
    passwordMatchValidator(formGroup: UntypedFormGroup) {
        const password = formGroup.get('password');
        const confirmPassword = formGroup.get('confirmPassword');
        if (confirmPassword.errors && !confirmPassword.errors.passwordMismatch) {
            return;
        }
        if (password.value !== confirmPassword.value) {
            confirmPassword.setErrors({ passwordMismatch: true });
        } else {
            confirmPassword.setErrors(null);
        }
    }

    reset() {
        this.submitted = true;

        // Stop if form is invalid
        if (this.resetForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.reset(this.token, this.f.password.value)
            .subscribe(
                result => {
                    if (result === true) {
                        this.sent = true;
                        this.loading = false;
                    } else {
                        this.error = 'Password reset failed. Please try again.';
                        this.loading = false;
                    }
                },
                error => {
                    // Handle API errors, including password complexity errors
                    if (error && error.error && error.error.message) {
                        this.error = error.error.message;
                    } else {
                        this.error = 'Password reset failed. Please try again or request a new reset link.';
                    }
                    this.loading = false;
                }
            );
    }

}
